import { v4 as uuid } from 'uuid';

export const generateUUID = (): string => {
  return uuid();
};

export const generateHash = (input: string): string => {
  return (input.match(/([0-9a-zA-Z ])/g)?.join("") || "").substring(0, 32).padEnd(32, "0");
};

export const generateRandomNumber = (max = 1000): number => {
  return Math.floor(Math.random() * max);
};